var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nsc-radio-group" },
    [
      _c(
        "VRadioGroup",
        {
          attrs: { label: _vm.label, name: _vm.name, disabled: !_vm.enabled },
          on: { change: _vm.emitChange },
          model: {
            value: _vm.value,
            callback: function($$v) {
              _vm.value = $$v
            },
            expression: "value"
          }
        },
        _vm._l(_vm.items, function(item) {
          return _c("VRadio", {
            key: item.value,
            staticClass: "nsc-radio-option",
            attrs: { color: _vm.color, ripple: false, value: item.value },
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function() {
                    return [
                      _c("div", {
                        staticClass: "nsc-radio-option nsc-radio-option-label",
                        domProps: { innerHTML: _vm._s(item.name) }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              true
            )
          })
        }),
        1
      ),
      _vm._v(" "),
      _vm.$slots["additional"] || _vm.$scopedSlots["additional"]
        ? _c(
            "div",
            {
              staticClass: "nsc-additional",
              style: { "margin-left": _vm.size + "px" }
            },
            [_vm._t("additional")],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }